// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

// API Endpoints
export const API_ENDPOINTS = {
  // Video & Cameras
  CAMERAS: '/video/cameras',
  VIDEO_STREAM: '/video/stream',
  DISPLAY_STATUS: '/video/display/status',

  // Unknown Faces
  UNKNOWN_LIST: '/faces/unknown/list',
  UNKNOWN_LOGS: '/faces/unknown/{id}/logs',
  UNKNOWN_PHOTOS: '/faces/unknown/{id}/photos/list',
  UNKNOWN_PHOTO: '/faces/unknown/{id}/photo',
  PROMOTE_UNKNOWN: '/faces/promote_unknown',

  // Employees
  EMPLOYEE_LIST: '/employees/list',
  EMPLOYEE_SEARCH: '/employees/search',
  EMPLOYEE_LOGS: '/employees/{id}/logs',
  REGISTER_EMPLOYEE: '/faces/register_new_employee',

  // Reports
  DAILY_REPORT: '/employees/{id}/reports/daily',
  WEEKLY_REPORT: '/employees/{id}/reports/weekly',
  MONTHLY_REPORT: '/employees/{id}/reports/monthly',

  // Analytics & Dashboard
  DASHBOARD_ANALYTICS: '/analytics/dashboard',
  EMOTION_DISTRIBUTION: '/analytics/emotions/distribution',

  // Crossings Report
  CROSSINGS_REPORT: '/crossings/report',
  CROSSINGS_EMPLOYEE: '/crossings/employee/{id}',
  CROSSINGS_DAILY_SUMMARY: '/crossings/daily-summary',
  CROSSINGS_TOP_CROSSERS: '/crossings/top-crossers',

  // Legacy
  LAST_SEEN: '/faces/known/last_seen',
  EMOTION_REPORT: '/reports/emotion'
};

// Emotion Colors (#B4A0F7 Purple Theme) - Only 4 emotions
export const EMOTION_COLORS = {
  Happy: '#B8E6D5',     // Soft mint
  Sad: '#A8C5E8',       // Soft blue
  Angry: '#F5B8C8',     // Soft pink
  Neutral: '#E0E0E0'    // Soft gray
};

// Emotion Icons - Only 4 emotions (Text-based for professional appearance)
export const EMOTION_ICONS = {
  Happy: 'H',
  Sad: 'S',
  Angry: 'A',
  Neutral: 'N'
};

// Pagination
export const DEFAULT_PAGE_SIZE = 12;
export const PAGE_SIZE_OPTIONS = ['12', '24', '48', '96'];

// Date Formats
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const DISPLAY_DATE_FORMAT = 'MMM DD, YYYY';
export const DISPLAY_DATETIME_FORMAT = 'MMM DD, YYYY HH:mm';

// Theme Colors - Purple Theme (#B4A0F7 based)
export const THEME_COLORS = {
  primary: '#B4A0F7',        // Main purple
  primaryDark: '#9B7FED',
  primaryLight: '#CCBFF9',
  secondary: '#B8E6D5',      // Soft mint
  success: '#B8E6D5',        // Soft mint
  warning: '#FFD4A8',        // Soft orange
  error: '#F5B8C8',          // Soft pink
  info: '#A8C5E8',           // Soft blue
  background: '#FAFBFC',     // Very light
  cardBackground: '#ffffff',
  textPrimary: '#4A5568',    // Soft charcoal
  textSecondary: '#A0AEC0',  // Soft gray
  border: '#E8E4F7',         // Light purple tint
  borderLight: '#F3F1FB',    // Very light purple
  shadow: 'rgba(180, 160, 247, 0.08)',
  gradientStart: '#B4A0F7',
  gradientEnd: '#CCBFF9'
};

// Chart Colors (Purple Theme Palette)
export const CHART_COLORS = [
  '#B4A0F7', // Main purple
  '#B8E6D5', // Soft mint
  '#FFD4A8', // Soft orange
  '#F5B8C8', // Soft pink
  '#A8C5E8', // Soft blue
  '#D4C4F7', // Light purple
  '#F5E6A8', // Soft yellow
  '#C8E6F5'  // Soft cyan
];

// Status Colors (Purple Theme)
export const STATUS_COLORS = {
  active: '#B8E6D5',    // Soft mint
  inactive: '#E0E0E0',  // Soft gray
  pending: '#FFD4A8',   // Soft orange
  error: '#F5B8C8'      // Soft pink
};
